import { FC } from 'react';
import { Input } from 'antd';
import type { InputProps } from 'antd/lib/input';
import styles from './index.module.scss';
import cs from 'classnames';

const InputCore: FC<InputProps> = ({ className, ...props }) => {
  return <Input className={cs([styles['input'], className])} {...props} />;
};

export default InputCore;
